import { gql } from '@apollo/client'

export const GET_SCHOOLS_BY_EMAIL = gql`
  query GetSchoolsByEmail($email: String!, $page: Int, $perPage: Int) {
    studentSchools(email: $email, page: $page, perPage: $perPage) {
      schools {
        id
        name
        organizationId
        url
        logo
      }
      totalPages
      totalCount
      currentPage
    }
  }
`
